import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2e3ebfcb&scoped=true&"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=2e3ebfcb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3ebfcb",
  null
  
)

export default component.exports